import axios from "axios";
import Cookie from 'react-cookies';
// const token = Coo;
const Axios = axios.create({
    baseURL: 'https://tasteplace.com.ng/tpi/',
    headers: {
        "Authorization": "Bearer "+Cookie.load('token')
    }
});

export default Axios;